module.exports = __webpack_public_path__ + "img/level3addon_running_gun.3703b352.png";